import { Task, Timestamp, WeekDays } from '@griply/types';
import { endOfDay, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';

import { getDueTaskPlanning, getTaskPlanning } from './get-task-planning';

export type GetTaskPlannedOccurrenceForDateOptions = {
  weekStartsOn: WeekDays;
  today: Timestamp;
  uncompletedOnly?: boolean;
};

export const getTaskPlannedOccurrenceForDate = (
  task: Task,
  date: Timestamp,
  {
    weekStartsOn,
    today,
    uncompletedOnly = true,
  }: GetTaskPlannedOccurrenceForDateOptions,
) => {
  const planning = getTaskPlanning(task, {
    startDate: startOfDay(date),
    endDate: endOfDay(date),
    today,
    weekStartsOn,
    uncompletedOnly,
  });
  const plannedOnDate = planning.find(({ date: _date }) =>
    isSameDay(_date, date),
  );

  if (plannedOnDate) {
    return plannedOnDate;
  }

  if (isSameDay(date, today) || isBefore(date, today)) {
    const duePlanning = getDueTaskPlanning(task, {
      date,
      today,
      weekStartsOn,
      uncompletedOnly,
    });

    return duePlanning[0];
  }

  return planning.find(({ date: _date }) => isAfter(_date, date));
};
